import { useState, useEffect } from 'react';

export type ThemeMode = 'light' | 'dark' | 'retro';

export function useThemeMode() {
  const [themeMode, setThemeMode] = useState<ThemeMode>(() => {
    const saved = localStorage.getItem('themeMode');
    return (saved as ThemeMode) || 'light';
  });

  useEffect(() => {
    localStorage.setItem('themeMode', themeMode);
  }, [themeMode]);

  const toggleTheme = (ctrlKey = false) => {
    if (ctrlKey) {
      // Ctrl+click: toggle retro theme
      setThemeMode(themeMode === 'retro' ? 'light' : 'retro');
    } else {
      // Regular click: cycle between light and dark only
      if (themeMode === 'retro') {
        setThemeMode('light');
      } else {
        setThemeMode(themeMode === 'light' ? 'dark' : 'light');
      }
    }
  };

  // Legacy support
  const isDarkMode = themeMode === 'dark';
  const toggleDarkMode = toggleTheme;

  return { themeMode, toggleTheme, isDarkMode, toggleDarkMode };
}